import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import useBreadcrumbsStore from '@/app/shared/infrastructure/state/breadcrumbs';

export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumbs',
  setup(__props) {

const store = useBreadcrumbsStore();

return (_ctx: any,_cache: any) => {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!

  return (_openBlock(), _createBlock(_component_v_breadcrumbs, {
    items: _unref(store).items
  }, null, 8, ["items"]))
}
}

})